import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/home",
    name: "Home",
    meta: {
      title: "智慧社区"
    },
    component: () => import("../views/Home.vue")
  },
  {
    path: "/iframe",
    name: "Iframe",
    component: () => import("../views/Iframe.vue")
  },
  {
    path: "/news-list-page",
    name: "NewsListPage",
    component: () => import("../views/NewsListPage.vue")
  },
  {
    path: "/party-building",
    name: "PartyBuilding",
    meta: {
      title: "党建"
    },
    component: () => import("../views/PartyBuilding.vue")
  },
  {
    path: "/all-media",
    name: "AllMedia",
    meta: {
      keepAlive: true,
      title: "铜梁全媒体"
    },
    component: () => import("../views/AllMedia.vue")
  },
  {
    path: "/community-info",
    name: "community-info",
    meta: {
      title: "社区消息"
    },
    component: () => import("../views/CommunityInfo.vue")
  },
  {
    path: "/select-street",
    name: "select-street",
    meta: {
      title: "选择街镇部门"
    },
    component: () => import("../views/SelectStreet.vue")
  },
  {
    path: "/leave-message",
    name: "leave-message",
    meta: {
      needToken: true,
      title: "留言互动"
    },
    component: () => import("../views/LeaveMessage.vue")
  },
  {
    path: "/",
    name: "business-service",
    meta: {
      keepAlive: true
    },
    component: () => import("../views/BusinessService.vue")
  },
  {
    path: "/video-details",
    name: "video-details",
    component: () => import("../views/VideoDetails.vue")
  }
];
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});
export default router;
